import React from "react";
import useStyles from "./styles";
import { OutOfStockProductsTableProps } from "./types";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";

import moment from "moment";
import StatTable from "../../components/StatTable";
import { useI18n } from "../../../../hooks/useI18n";

const OutOfStockTable = ({
  outOfStockProducts
}: OutOfStockProductsTableProps) => {
  const { t } = useI18n();
  const classes = useStyles();
  const currentlyOut = "Yes";

  return (
    <div>
      <StatTable
        exportName={"Out of stock statistics"}
        isLoading={false}
        columns={[
          { title: "Product", field: "productName" },
          {
            title: "Currently out of stock",
            field: "outOfStock",
            defaultSort: "desc"
          },
          {
            title: "Out of stock count",
            field: "outOfStockCount"
          }
        ]}
        data={outOfStockProducts.map(m => ({
          productName: m.productName,
          outOfStockCount: m.outOfStockCount,
          outOfStock: m.outOfStockPeriods.find(osp => osp.periodEnd == null)
            ? currentlyOut
            : "No",
          outOfStockPeriods: m.outOfStockPeriods
        }))}
        detailPanel={(rowData: any) => {
          return (
            <Table
              size="small"
              className={classes.table}
              key={rowData.productName + "table"}
            >
              <TableHead key={rowData.productName + "head"}>
                <TableRow
                  className={classes.tableHeader}
                  key={rowData.productName + "row"}
                >
                  <TableCell />
                  <TableCell>{t("common.messages.timeOutOfStock")}</TableCell>
                  <TableCell>{t("common.messages.outOfStockFrom")}</TableCell>
                  <TableCell>{t("common.messages.outOfStockTo")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody key={rowData.productName}>
                {rowData.outOfStockPeriods.map((osp: any) => {
                  let endDate =
                    osp.periodEnd != null
                      ? moment(osp.periodEnd).format("YYYY-MM-DD hh:mm")
                      : "Currently out of stock";
                  return (
                    <TableRow key={osp.timeOutOfStock} className={classes.row}>
                      <TableCell />
                      <TableCell>{osp.timeOutOfStock}</TableCell>
                      <TableCell>
                        {moment(osp.periodStart).format("YYYY-MM-DD hh:mm")}
                      </TableCell>
                      <TableCell>{endDate}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          );
        }}
        dense
      />
    </div>
  );
};
export default OutOfStockTable;
